import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { AppName } from 'src/environments/environment-d'

const { TAPI } = environment
export type TokeetUser = any
@Injectable()
export class TapiService {
  constructor(
    private http: HttpClient,
    @Inject('APP_NAME') private app: AppName,
  ) { }

  private getAppName(): string {
    return this.app === 'owners' ? 'ownercenter' : this.app;
  }

  forgot(email: string): Observable<void> {
    return this.http.post<void>(`${TAPI}/user/password/forgot`, { email, app: this.getAppName() })
  }

  recover({ t, k }: { t: string, k: string }): Observable<TokeetUser> {
    return this.http.post<TokeetUser>(`${TAPI}/user/password/recover`, { t, k, app: this.getAppName() })
  }

  reset({pkey, token}: {pkey: string, token: string}, payload: { password1: string, password2: string }): Observable<void> {
    return this.http.put<void>(`${TAPI}/user/password/${pkey}`, { ...payload, app: this.getAppName() }, {
      headers: { Authorization: token }
    })
  }
}
